<div class="deleteTopHeader">
    <div class="delete_add_title fs-20">{{'common.text_account_closeAccount_popup_title'|cxTranslate}}</div>
    <div class="delete_close_icon" mat-dialog-close><img src="/icons/close-light-grey.svg" alt="Close Popup"
            width="20px">
    </div>
</div>
<mat-dialog-content>
    <p class="fs-20 mb-5">{{'common.text_account_closeAccount_popup_confirm'|cxTranslate}}</p>
    <button mat-dialog-close (click)="closeAcc()"
        class="btn btn-block btn-primary close-my-account-btn mb-3">{{'common.text_account_closeAccount_popup_action'|cxTranslate}}
        <img class="hover-img" src="/icons/link-dark-grey.svg" style="width: 20px;">
    </button>
    <button class="btn btn-block btn-launch btn-primary"
        mat-dialog-close>{{'common.text_account_quote_cancel'|cxTranslate}}</button>
</mat-dialog-content>